import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgSclComponent } from './svg-scl.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [SvgSclComponent],
  exports: [
    SvgSclComponent
  ]
})
export class SvgSclModule { }